<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-责任签署-添加
    -->
    <el-dialog
    title="添加责任签署"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">

    <el-form-item label="责任签署名称" prop="name"><el-input v-model="form.name" placeholder="请输入责任签署名称" class="max-w460"></el-input></el-form-item>
    <el-form-item label="签名分类" prop="sign_type_id">
      <el-select 
        v-model="form.sign_type_id" 
        placeholder="请选择分类"
        style="width: 100%;"
        clearable
        filterable
      >
        <el-option
          v-for="dept in signTypeList"
          :key="dept.sign_type_id"
          :label="dept.name"
          :value="dept.sign_type_id"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="所属组织" prop="ma_company_id">
      <el-select 
        v-model="form.ma_company_id" 
        placeholder="请选择组织"
        style="width: 100%;"
        clearable
        filterable
      >
        <el-option
          v-for="dept in maCompanyList"
          :key="dept.ma_company_id"
          :label="dept.name"
          :value="dept.ma_company_id"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="绑定用户" prop="ma_employee_id">
      <el-select 
        v-model="form.ma_employee_id" 
        placeholder="请选择用户"
        style="width: 100%;"
        clearable
        filterable
      >
        <el-option
          v-for="dept in employeeList"
          :key="dept.ma_employee_id"
          :label="dept.name + (dept.phone ? ' (' + dept.phone + ')' : '')"
          :value="dept.ma_employee_id"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="排序" prop="sort">
      <el-input-number v-model="form.sort" :min="0" :max="999" class="max-w460"></el-input-number>
    </el-form-item>
          
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
     <!--业务附件上传组件-->
     <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    <Upload v-if="isuploadFile" :isupload="isuploadFile" @returnImgs="returnFilesFunc">上传文件</Upload>
 </div>
</el-dialog>
</template>

<script>
import Ma_resp_signingApi from '@/api/ma_resp_signing.js';
import Ma_ygApi from '@/api/ma_yg.js';
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
import AfuncApi from '@/api/afunc.js';

export default {
  components: {
     /*图片上传*/
     Upload: Upload,
     draggable,
     Uediter
  },
  data() {
    return {
      maCompanyList: [],
      employeeList: [],
      auditList:[],
      signTypeList:[],
         /*是否上传图片*/
         isupload: false,
      isImg: false,  
         /*富文本配置*/
         ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name: '',
        code: 'custom',
        image:[],
        // categorya:{},
        sort:50,
        intro:"",
        bannar:[]
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入责任签署名称', trigger: 'blur' }],
        sign_type_id: [{ required: true, message: '请选择分类', trigger: 'blur' }],
        ma_company_id: [{ required: true, message: '请选择组织', trigger: 'blur' }],
        ma_employee_id: [{ required: true, message: '请绑定用户', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      code:"album",
      isuploadFile:false
    };
  },
  created() {
    this.loadOrganization();
    this.loadSigntype();
    this.loadAuditList();
    this.loadEmployeeList();
    this.dialogVisible = this.open_add;
  },
  props: ["open_add"],
  methods: {
    async loadEmployeeList() {
      try {
        const response = await Ma_ygApi.list({}, true);
        
        if (!response) {
          this.$message.warning('员工列表接口返回为空');
          this.employeeList = [];
          return;
        }
        
        if (response.code === 1 && response.data.list.data) {
          this.employeeList = response.data.list.data || [];
        } else {
          this.$message.warning('获取员工列表失败：' + (response.msg || '未知错误'));
          this.employeeList = [];
        }
      } catch (error) {
        console.error('加载员工列表失败:', error);
        this.$message.error('加载员工列表失败，请稍后重试');
        this.employeeList = [];
      }
    },
    returnFilesFunc(e) {
      this.uploadStatus = ''
      if (e != null && e.length > 0) {
        this.form.sign_type_id = e[0].file_path;
        this.uploadStatus = 'success'
        this.isFileUploaded = true;
        this.$nextTick(() => {
          this.$refs.formRef.validateField('sign_type_id')
        })
      }
      this.isuploadFile = false;
    },
    openFileUpload() {
      this.isuploadFile = true;
    },
    async loadSigntype() {
      try {
        const response = await AfuncApi.call({
          model: 'sign_type',
          action: 'getList',
        });
        
        if (!response) {
          this.$message.warning('分类列表接口返回为空');
          this.signTypeList = [];
          return;
        }
        
        if (response.code === 1 && response.data.list.data) {
          this.signTypeList = response.data.list.data || [];
        } else {
          this.$message.warning('获取分类列表失败：' + (response.msg || '未知错误'));
          this.signTypeList = [];
        }
      } catch (error) {
        console.error('加载分类列表失败:', error);
        this.$message.error('加载分类列表失败，请稍后重试');
        this.signTypeList = [];
      }
    },
    async loadAuditList() {
      try {
        const response = await AfuncApi.call({
          model: 'ma_employee',
          action: 'index',
        });
        
        if (!response) {
          this.$message.warning('审核人列表接口返回为空');
          this.auditList = [];
          return;
        }
        
        if (response.code === 1 && response.data.list.data) {
          this.auditList = response.data.list.data || [];
        } else {
          this.$message.warning('获取审核人列表失败：' + (response.msg || '未知错误'));
          this.auditList = [];
        }
      } catch (error) {
        console.error('加载审核人列表失败:', error);
        this.$message.error('加载审核人列表失败，请稍后重试');
        this.auditList = [];
      }
    },
    async loadOrganization() {
      try {
        const response = await AfuncApi.call({
          model: 'ma_company',
          action: 'getList',
        });
        
        if (!response) {
          this.$message.warning('组织列表接口返回为空');
          this.maCompanyList = [];
          return;
        }
        
        if (response.code === 1 && response.data.list.data) {
          this.maCompanyList = response.data.list.data || [];
        } else {
          this.$message.warning('获取组织列表失败：' + (response.msg || '未知错误'));
          this.maCompanyList = [];
        }
      } catch (error) {
        console.error('加载组织列表失败:', error);
        this.$message.error('加载组织列表失败，请稍后重试');
        this.maCompanyList = [];
      }
    },
    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },


     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      //form.intro = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Ma_resp_signingApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
     /*打开上传图片*/
     openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传业务附件*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除业务附件*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },

  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/ma_resp_signing/index/part/add.vue